import { Form, Modal } from "antd";
import { useUserModalActions } from "./useUserModals";
import { FormValues, UserForm } from "./userForm";

interface CreateUserModalProps {
  isOpen: boolean;
  close: () => void;
  onRefresh?: () => void;
  initialValues?: Partial<FormValues>;
}

export const CreateUserModal = ({
  isOpen,
  close,
  onRefresh,
  initialValues = {},
}: CreateUserModalProps) => {
  const [form] = Form.useForm<FormValues>();
  const { createUser, loading } = useUserModalActions({
    onRefresh,
  });

  const handleClose = () => {
    form.resetFields();
    close();
  };

  const handleSubmit = async (values: FormValues) => {
    try {
      await createUser({
        username: values.username,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        workspace_role: values.role.toLowerCase() as
          | "admin"
          | "editor"
          | "viewer",
      });

      form.resetFields();
      close();
    } catch (err) {
      console.error("Error creating user:", err);
    }
  };

  return (
    <Modal
      open={isOpen}
      title="Create New User"
      onCancel={handleClose}
      onOk={() => {
        form.submit();
      }}
      okText="Save"
      closable={true}
      confirmLoading={loading}
      destroyOnHidden
    >
      <UserForm
        form={form}
        initialValues={initialValues}
        onFinish={handleSubmit}
        loading={loading}
      />
    </Modal>
  );
};
